<template>
  <div class="activity-analysis">
    <PageNav>
      <div class="common-reportTemp">
        <div
          class="reporthead-nav flex-all pt10 pb10 pl20 pr20 bg-white height50"
        >
          <div class="ct-head-left flex-al">
            <span class="color-333 fs18">{{ $t("Analysisreport.da") }}</span>
          </div>
        </div>
        <div class="tab-menu-list">
          <el-menu
            default-active="1"
            background-color="#ffffff"
            text-color="#2A304D"
          >
            <el-menu-item
              v-for="(item, index) in innerSlider"
              :key="index"
              :index="String(index + 1)"
            >
              <router-link tag="div" :to="{ path: `${item.module_markurl}` }">
                {{ item.title }}
              </router-link>
            </el-menu-item>
          </el-menu>
        </div>
        <router-view></router-view>
      </div>
    </PageNav>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
export default {
  components: { PageNav },
  computed: {
    innerSlider() {
      return this.$store.state.INNER_SLIDER;
    },
  },
};
</script>
<style lang="less">
@import url("../../assets/less/report");
.activity-analysis {
  .common-reportTemp {
    position: relative;
  }
  .export-btn {
    top: 12px;
    right: 20px;
    position: absolute;
  }
}
</style>
